import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Share2, Copy, MessageCircle, Facebook, Twitter, Linkedin, Mail } from 'lucide-react';
import { toast } from 'sonner';

const SocialShareButtons = ({ referralLink, referralCode }) => {
  const shareMessage = `🌐 Join Netix Fibernet and earn amazing commissions! Get high-speed internet with the best service. Use my referral code: ${referralCode}\n\n${referralLink}`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(referralLink);
    toast.success('Referral link copied to clipboard!');
  };

  const shareOnWhatsApp = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(shareMessage)}`;
    window.open(whatsappUrl, '_blank');
  };

  const shareOnFacebook = () => {
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(referralLink)}`;
    window.open(facebookUrl, '_blank');
  };

  const shareOnTwitter = () => {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareMessage)}`;
    window.open(twitterUrl, '_blank');
  };

  const shareOnLinkedIn = () => {
    const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(referralLink)}`;
    window.open(linkedinUrl, '_blank');
  };

  const shareViaEmail = () => {
    const emailSubject = 'Join Netix Fibernet - High-Speed Internet';
    const emailBody = shareMessage;
    const mailtoUrl = `mailto:?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
    window.location.href = mailtoUrl;
  };

  return (
    <Card className="border-3 border-green-300 shadow-lg bg-white/90 backdrop-blur-sm">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Share2 className="h-5 w-5 text-green-600" />
          Share Your Referral Link
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {/* Referral Link Display */}
          <div className="flex gap-2">
            <div className="flex-1 px-4 py-3 bg-gray-100 rounded-lg text-sm truncate">
              {referralLink}
            </div>
            <Button 
              onClick={copyToClipboard}
              className="bg-green-600 hover:bg-green-700 text-white"
            >
              <Copy className="h-4 w-4" />
            </Button>
          </div>

          {/* Social Share Buttons */}
          <div className="grid grid-cols-2 gap-3">
            <Button 
              onClick={shareOnWhatsApp}
              className="bg-green-500 hover:bg-green-600 text-white"
            >
              <MessageCircle className="h-4 w-4 mr-2" />
              WhatsApp
            </Button>
            
            <Button 
              onClick={shareOnFacebook}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              <Facebook className="h-4 w-4 mr-2" />
              Facebook
            </Button>
            
            <Button 
              onClick={shareOnTwitter}
              className="bg-sky-500 hover:bg-sky-600 text-white"
            >
              <Twitter className="h-4 w-4 mr-2" />
              Twitter
            </Button>
            
            <Button 
              onClick={shareOnLinkedIn}
              className="bg-blue-700 hover:bg-blue-800 text-white"
            >
              <Linkedin className="h-4 w-4 mr-2" />
              LinkedIn
            </Button>
            
            <Button 
              onClick={shareViaEmail}
              className="bg-gray-700 hover:bg-gray-800 text-white col-span-2"
            >
              <Mail className="h-4 w-4 mr-2" />
              Email
            </Button>
          </div>

          <p className="text-xs text-gray-500 text-center mt-2">
            Share your referral link and start earning commissions today!
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default SocialShareButtons;